import React, { Component } from 'react';
import '../App.css';
import Dimensions from 'react-dimensions';
const sancoLogo = require('../media/sancoIcon_trans.png');


class VideoUploader extends Component {
  
  constructor() {
    super();
    this.state = {
      
    };  
  }
  
  componentDidMount() {
  }
  
  render() {
    return (
      <div className='wrapper'>
       
      </div>
    );
  }
}

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/pages/VideoUploader.js